import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  avatar: {
    height: '80px',
    width: '80px',
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    background: '#BDBDBD',
  },
  displayName: {
    color: '#212121',
  },
  location: {
    color: '#616161',
  },
  facility: {
    color: '#616161',
    fontSize: '14px',
  },
  linkButton: {
    marginTop: theme.spacing(1),
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontFamily: 'Roboto Condensed',
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: 'inherit',
      textDecoration: 'underline',
    },
  },
  cardWrapper: {
    background: theme.palette.primary.contrastText,
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: theme.spacing(2),
    height: '160px',
    '&.coachingChannel': {
      background: '#FAFAFA',
    },
  },
}))

export default useStyles
